<template>
    <div>

      <!--iframe
        class="video-frame"
        :src="currentVideo + '?autoplay=1&background=1'"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe-->
  
      <div :style="getContainerStyle(false)">
        <div 
        class="video-container"
      >
        <iframe
          key="iframe1"
          class="video-frame"
          :src="this.currentVideo(this.videoIndex0) + '?autoplay=1&background=1#t=0s'"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
        </div>
      </div>

      <div :style="getContainerStyle(true)">
        <div 
        class="video-container"
      >
        <iframe
          key="iframe2"
          class="video-frame"
          :src="this.currentVideo(this.videoIndex1) + '?autoplay=1&background=1#t=0s'"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
        </div>
      </div>

      <div class="arrow-frame-left"
      @mouseover="inLeftThird = true" 
      @mouseleave="inLeftThird = false"

      @click="changeVideo(false)">
      <div 
        class="arrow arrow-left" 
        v-show="inLeftThird"
      >
        <svg width="100" height="100">
          <polyline points="70,10 30,50 70,90" stroke="#FFFFFFcc" stroke-width="10" fill="none" />
        </svg>
      </div>
      </div>


      <div class="arrow-frame-right"
        @mouseover="inRightThird = true" 
        @mouseleave="inRightThird = false"
        @click="changeVideo(true)"
      >
        <div 
          class="arrow arrow-right" 
          v-show="inRightThird" 
        >
          <svg width="100" height="100">
            <polyline points="30,10 70,50 30,90" stroke="#FFFFFFcc" stroke-width="10" fill="none" />
          </svg>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import gsap from "gsap";

  export default {
    data() {
      return {
        videoUrls: [
          'https://player.vimeo.com/video/828669626',
          'https://player.vimeo.com/video/828017093',
          'https://player.vimeo.com/video/697028620',
          // Add more URLs here
        ],
        currentIndex: 0,
        showArrows: false,
        inLeftThird: false,
        inRightThird: false,

        swapVideoIndex: false,
        videoIndex0: 0,
        videoIndex1: 1,

        gSlide: {
          v: 1
        }
      }
    },
    computed: {

    },
    methods: {
      getContainerStyle(_videoIndex) {

        return {
          width: '100%',
          position: 'absolute',
          left: (this.swapVideoIndex == _videoIndex ? (-100 * (1-this.gSlide.v)) : (this.gSlide.v * 100)) + "%"
        }
      },
      currentVideo(_id) {
        return this.videoUrls[_id];
      },
      changeVideo(_forward=true) {

        this.currentIndex = (this.currentIndex + (_forward ? 1 : -1)) % this.videoUrls.length;
        this.swapVideoIndex = !this.swapVideoIndex

        if (this.swapVideoIndex) {
          this.videoIndex1 = this.currentIndex
        } else {
          this.videoIndex0 = this.currentIndex
        }

        this.gSlide.v = 0;
        gsap.to(this.gSlide, {
          duration: 1,
          v: 1,
          onComplete: this.setNextIndex()
        })

      },
      setNextIndex() {

        console.log("* Set Next")
        let _nextIndex = (this.currentIndex + 1) % this.videoUrls.length;
        if (this.swapVideoIndex) {
          this.videoIndex0 = _nextIndex
        } else {
          this.videoIndex1 = _nextIndex
        }
      }
      /*prevVideo() {
        this.currentIndex = (this.currentIndex - 1 + this.videoUrls.length) % this.videoUrls.length;
      }*/
    }
  }
  </script>
  
  <style scoped>
  .video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    position: relative;

    font-size: 120px;
  }
  
  .arrow-frame-left {
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 50%;
  }

  .arrow-frame-right {
    height: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    width: 50%;
  }

  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100px;
    height: 100px;
  }
  
  .arrow-left {
    left: 100px;
  }
  
  .arrow-right {
    right: 100px;
  }
  
  .video-frame {
    width: 90vw;
    height: 50.625vw; /* This is 9:16 aspect ratio. Adjust this value based on the aspect ratio of your video */
  }
  </style>
  